import { Component, OnInit } from '@angular/core';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { BillingOrder } from 'src/app/models/billingorder.model';
import { Lease } from 'src/app/models/lease.model';
import { TableColumn } from 'src/app/models/table-columns';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { Payment } from 'src/app/models/payment.model';
import { IPaymentMetadata, PaymentService } from 'src/app/services/payment.service';
import { flatten } from 'lodash-es';
import { AccountService } from 'src/app/services';
import { first } from 'rxjs';

@Component({
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent extends ScrBaseComponent implements OnInit {


  public tableColumns!: TableColumn[];
  public payment!: Payment;
  public availableCredit?: number;
  public meta!: IPaymentMetadata;
  public leases!: Lease[];
  public orderIds?: string;
  public firstOrderId!: number;
  public firstLease!: Lease;
  public billingInfo!: BillingOrder | Payment;

  constructor(private accountService: AccountService, private paymentService: PaymentService, private scService: ShortCodesService) {
    super();

    this.tableColumns = [
      { field: 'orderId' },
      { field: 'scId' },
      { field: 'description' },
      { field: 'autoRenew' },
      { field: 'addToMonthlyBilling' },
      { field: 'listPrice' },
      { field: 'discount' },
      { field: 'price' }
    ];

    this.accountService.getAccount().pipe(first()).subscribe(rsp => {
      if (rsp.account.monBillEnabled !== true) {
        this.tableColumns = this.tableColumns.filter(tc => tc.field !== 'addToMonthlyBilling');
      }
      this.localizeTableColumns(this.tableColumns);
    });
  }

  ngOnInit(): void {

    this.availableCredit = history?.state?.availableCredit;
    // console.debug('received available credit from history ' + this.availableCredit);

    if (history.state.payment && history.state.meta) {
      this.payment = history.state.payment;
      this.meta = history.state.meta;
      this.orderIds = this.payment.orders?.map(o => o.orderId).join(', ');
      this.firstOrderId = this.payment.orders ? this.payment.orders[0].orderId : 0;
      this.leases = flatten(this.payment.orders?.map(o => o.leases));
      this.firstLease = this.leases[0];
      this.billingInfo = this.payment;


      this.adjustColumnsForDiscount(this.leases);
    }

    if (!this.payment && history.state.paymentId) {
      this.observe(this.paymentService.getPaymentForThankYou(history.state.paymentId, undefined, undefined), rsp => {
        this.payment = rsp.payment;
        this.meta = rsp.meta;
        // the back end can return the available credit but it could be out of date if a payment
        // was just made and wasn't sync'd up with Netsuite.  The client can provide the current
        // up-to-date value in the history state.  If it's there, don't use the back-end provided value.
        if (rsp.accountAvailableCredit && this.availableCredit === undefined) {
          this.availableCredit = rsp.accountAvailableCredit;
          this.log.trace('used available credit from response of ' + rsp.accountAvailableCredit);
        }
        this.orderIds = rsp.payment.orders?.map(o => o.orderId).join(', ');
        this.firstOrderId = rsp.payment.orders ? rsp.payment.orders[0].orderId : 0;
        this.leases = flatten(rsp.payment.orders?.map(o => o.leases));
        this.firstLease = this.leases[0];
        this.billingInfo = rsp.payment;
        this.adjustColumnsForDiscount(this.leases);
      });
    }

  }

  private adjustColumnsForDiscount(leases: Lease[]): void {

    const anyWithDiscount = leases.some(l => l.discountAmount !== 0 && l.discountList !== undefined && l.discountList.length > 0);
    if (!anyWithDiscount) {
      this.tableColumns = this.tableColumns.filter(tc => tc.field !== 'discount');
    }
  }

  downloadReceiptPdf() {
    this.clearMessages();
    const po = this.createDownloadPartialBlobResponseObserver();
    this.scService.getReceiptPdfWithResponse(this.payment.paymentId ?? 0).subscribe(po);
  }
}
